import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ConfigurationService, TrackingV2Service } from '@draeger-academy/common';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';

@Component({
    selector: 'da-country-selection',
    templateUrl: './country-selection.component.html',
    styleUrls: ['./country-selection.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CountrySelectionComponent implements OnInit, OnDestroy {
    @Input() countriesData: Array<any>;
    public isGeneralTerms: boolean;
    public isDataProtection: boolean;
    public isLegalNotice: boolean;
    public isNotice: boolean;
    public isLicenses: boolean;
    public isTermsAndConditionsOfSale: boolean;
    public isTransparency: boolean;
    public isSupplierIndentification: boolean;

    private _$countriesData: BehaviorSubject<Array<any>> = new BehaviorSubject(null);
    private _subscriptionCountriesData: Subscription;

    public get countriesData$(): Observable<Array<any>> {
        return this._$countriesData.asObservable();
    }

    constructor(
        private _configurationService: ConfigurationService,
        private _trackingV2Service: TrackingV2Service,
        private activatedRoute: ActivatedRoute
    ) {}

    ngOnDestroy(): void {
        if (this._subscriptionCountriesData) {
            this._subscriptionCountriesData.unsubscribe();
        }
    }

    ngOnInit(): void {
        this.isGeneralTerms = this.activatedRoute.snapshot.data['isGeneralTerms'];
        this.isDataProtection = this.activatedRoute.snapshot.data['isDataProtection'];
        this.isLegalNotice = this.activatedRoute.snapshot.data['isLegalNotice'];
        this.isNotice = this.activatedRoute.snapshot.data['isNotice'];
        this.isTransparency = this.activatedRoute.snapshot.data['isTransparency'];
        this.isLicenses = this.activatedRoute.snapshot.data['isLicenses'];
        this.isSupplierIndentification = this.activatedRoute.snapshot.data['isSupplierIndentification'];
        this.isTermsAndConditionsOfSale = this.activatedRoute.snapshot.data['isTermsAndConditionsOfSale'];

        this._subscriptionCountriesData = this._configurationService.$countriesData.subscribe((data) => {
            if (data && data.length > 0) {
                const _data = [];
                data.forEach((countryLinkListGroup, i) => {
                    const _items = countryLinkListGroup.Items.filter((countryLinkList, j) => {
                        const _countryLinkList = countryLinkList.LinkList.filter((site) => {
                            return site.enabled;
                        });
                        data[i].Items[j].linkList = _countryLinkList;
                        return _countryLinkList.length > 0;
                    });
                    data[i].items = _items;
                    if (_items.length > 0) {
                        _data.push(countryLinkListGroup);
                        this._$countriesData.next(_data);
                    }
                });
                this._$countriesData.next(_data);
            }
        });

        this._trackPage();

        const isPortal = this._configurationService.isPartnerPage();
        const currentPortal = this._configurationService.portalId;
        let site = this._configurationService.getSiteFromUrl();
        if (site) {
            site = this._configurationService.getSiteFromUrl().site;
        }
        const _site = isPortal ? currentPortal : site;

        localStorage.removeItem(`showMoreCourses${_site}`);
    }

    private _trackPage() {
        const _metaConfig = this._configurationService.MetaData;
        if (_metaConfig) {
            const _metadata = _metaConfig[0].value.filter((meta) => meta.key.toLowerCase() === 'pagetitle');
            const _pageTitle = _metadata ? _metadata[0] : null;
            this._trackingV2Service.loadTrackingScript();
            this._trackingV2Service.trackPage({
                template: 'CountrySelectionPage',
                title: _pageTitle.value + ' | CountrySelection'
            });
        }
    }

    public getCountryFlag(countryShort: string): string {
        const _country = countryShort.split('_').pop();
        const _countryLC = _country.toLowerCase();

        return `images/flags/${_countryLC}.png`;
    }

    public setCountryCookie(countryAndLang: string) {
        const d = new Date();
        d.setTime(d.getTime() + 365 * 24 * 60 * 60 * 1000);
        document.cookie = `SiteId=${countryAndLang}; expires=${d.toUTCString()}; path=/`;
    }
}
